const validate = (values) => {
    const errors = {};
  
    // if (!values.ObservationsToDetermineProtocols) {
    //     errors.ObservationsToDetermineProtocols = 'Please enter details';
    // }

    // if (!values.ParentOrCaregiverTraining) {
    //     errors.ParentOrCaregiverTraining = 'Please enter details';
    // }

    // if (!values.AssessmentOrTreatmentAndPlanning) {
    //     errors.AssessmentOrTreatmentAndPlanning = 'Please enter details';
    // }
    
    return errors;
  };
  export default validate;


// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_BCBA_BESTABA/validate.js